import {
    app,
    Component,
    ojs,
    component,
    payload,
    v,
    state,
} from "modular-openscriptjs";
import { empty, clearSearchSuggestion, isMobile } from "../../../helpers";
import { api, dc } from "../../../declarations";
import SearchResultProductView from "../../Views/SearchResultProductView";
import { dom } from "../../../fotastart";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(SearchResultProductView);

export default class CategoryProductsResult extends Component {
    categoryName = state("Category");

    pageMap = {
        categories: { next: 1, total: 0 },
    };

    constructor() {
        super();
        this.resetMap();
    }

    resetMap() {
        this.pageMap.categories = { next: 1, total: 0 };
    }

    $$ojs = {
        routeChanged: () => this.resetMap(),
    };

    $$app = {
        has: {
            searchQuery: (ed, event) => {
                this.resetMap();
                this.getCategories("c-cat-search-results");
            },
        },
    };

    render(...args) {
        return h.div(
            {
                class: "pt-3 pb-5 container mb-5 py-md-5",
            },
            h.h4(
                { class: "fw-bold mb-4 px-1" },
                "Search Results in ",
                v(this.categoryName, (c) => c.value),
            ),
            h.InfiniteScroll({
                child: h.div({
                    id: "c-cat-search-results",
                }),
                callback: (entries, observer, marker) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return;
                        this.populateCategories("c-cat-search-results", marker);
                    });
                },
            }),
            ...args,
        );
    }

    $_mounted(componentId) {
        let c = component(componentId);
        if (!c) return;

        // Fetch on mount in case query was pre-populated
        c.getCategories("c-cat-search-results");
    }

    async getCategories(holderId, spinnerHolder = null) {
        let page = this.pageMap.categories.next;
        let query = dc.searchQuery.value ?? "";
        const categoryId = router.params.categoryId;

        let spinner = null;
        if (spinnerHolder) {
            spinner = h.Spinner({ parent: spinnerHolder, resetParent: true });
        }

        let qs = {
            page,
            interval: 5, // We paginate by category, 5 per page is good because each has up to 10 products
        };

        if (empty(query)) {
            return;
        }

        qs.query = query;

        let res = await api.get(`/categories/${categoryId}/search/query`, qs, {
            silent: true,
        });

        if (res) {
            let categories = res.data.categories.data;
            let currentPage = res.data.categories.current_page;
            this.pageMap.categories.total = res.data.categories.total ?? 0;
            let category = res.data.category;

            this.categoryName.value = category?.name;

            const holder = dom.id(holderId);

            if (currentPage == 1) {
                dom.empty(holder);
            }

            for (let subcategory of categories) {
                if (
                    !dom.get(`[data-cat-result-id="${subcategory.id}"]`, holder)
                ) {
                    // Build the block for the category
                    h.div(
                        {
                            class: "mb-5",
                            parent: holder,
                            "data-cat-result-id": subcategory.id,
                        },
                        h.div(
                            {
                                class: "d-flex justify-content-between align-items-center mb-3 px-1",
                            },
                            h.h4({ class: "fw-bold m-0" }, subcategory.name),
                            h.span(
                                {
                                    class: "text-primary fw-bold cursor-pointer",
                                    role: "button",
                                    listeners: {
                                        click: () => {
                                            dc.currentCategory = subcategory;
                                            app("router").to(
                                                "category.all-products",
                                                {
                                                    categoryId: subcategory.id,
                                                },
                                            );
                                        },
                                    },
                                },
                                "Browse All",
                            ),
                        ),

                        h.div(
                            {
                                class: "d-flex flex-nowrap overflow-x-auto pb-3 gap-3 desktop-scrollbar",
                            },
                            subcategory.products.map((product) =>
                                h.SearchResultProductView(product, {
                                    class: "flex-shrink-0 h-100",
                                    style: isMobile()
                                        ? "width: 180px;"
                                        : "width: 280px;",
                                    listeners: {
                                        click: () => {
                                            broker.send(
                                                app("$e").product.needs.display,
                                                payload({ product }),
                                            );
                                        },
                                    },
                                }),
                            ),
                        ),
                    );
                }
            }

            if (empty(categories) && currentPage == 1) {
                this._showEmpty(holderId, "No results found in this category.");
            }

            if (!empty(categories)) {
                this.pageMap.categories.next = currentPage + 1;
            }
        }

        spinner?.remove();
        clearSearchSuggestion();
    }

    async populateCategories(holderId, marker) {
        this.getCategories(holderId, marker);
    }

    _showEmpty(holderId, message) {
        const holder = dom.id(holderId);
        if (!holder) return;

        h.div(
            {
                parent: holder,
                resetParent: true,
                class: "card border-0 rounded-4 w-100 p-5 text-center bg-white shadow-sm border border-light",
            },
            h.div(
                {
                    class: "text-muted d-flex flex-column align-items-center justify-content-center gap-3",
                },
                h.i({
                    class: "bi bi-search fs-1 text-secondary opacity-50",
                }),
                h.h5({ class: "fw-bold text-dark mb-0" }, message),
            ),
        );
    }
}

ojs(CategoryProductsResult);
